import { api } from '@/api'

export function deleteServiceAction(serviceSlug: string) {
  return api.v2.delete(`/services/${serviceSlug}`)
}
